export const CleaningIcon = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="64.000000pt"
    height="64.000000pt"
    viewBox="0 0 64.000000 64.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M300 598 c0 -18 -9 -41 -21 -54 -11 -12 -23 -40 -26 -63 l-6 -40 -32
24 c-27 21 -43 25 -104 25 l-72 0 3 -40 c1 -25 -4 -46 -15 -58 -23 -25 -21
-32 8 -32 14 0 37 11 50 24 29 29 35 25 28 -21 -4 -23 -2 -38 6 -43 10 -6 10
-12 0 -28 -10 -16 -10 -23 0 -35 10 -12 7 -20 -14 -41 -23 -23 -25 -32 -25
-115 l0 -90 259 -1 c223 0 262 2 275 16 13 13 16 43 16 172 -1 216 -12 239
-164 327 -60 36 -66 42 -66 72 0 33 0 33 -50 33 -50 0 -50 0 -50 -32z m80 -8
c0 -16 -7 -20 -30 -20 -23 0 -30 4 -30 20 0 16 7 20 30 20 23 0 30 -4 30 -20z
m77 -82 c129 -79 153 -114 153 -223 l0 -65 -170 0 -170 0 0 139 c0 125 2 141
21 165 32 40 82 36 166 -16z m-251 -62 c28 -23 28 -23 6 -30 -12 -4 -22 -14
-22 -22 0 -8 -10 -14 -23 -14 -17 0 -26 9 -36 35 -10 29 -17 35 -42 35 -16 0
-29 5 -29 10 0 6 26 10 59 10 49 0 65 -5 87 -24z m-126 -37 c-7 -11 -14 -19
-16 -16 -7 7 7 37 17 37 6 0 5 -9 -1 -21z m170 -71 c0 -45 -3 -59 -10 -48 -5
8 -10 32 -10 53 0 20 -5 37 -11 37 -5 0 -7 5 -4 10 3 6 13 10 21 10 11 0 14
-15 14 -62z m-40 12 c0 -5 -18 -10 -40 -10 -22 0 -40 5 -40 10 0 6 18 10 40
10 22 0 40 -4 40 -10z m18 -80 c12 -24 22 -55 22 -67 0 -22 -3 -23 -77 -23
l-77 0 29 30 c23 24 27 34 19 47 -17 27 5 64 36 61 18 -2 31 -15 48 -48z m382
-130 l0 -60 -170 0 -170 0 0 60 0 60 170 0 170 0 0 -60z m-360 -25 l0 -45 -75
0 -75 0 0 45 0 45 75 0 75 0 0 -45z m358 -67 c-6 -18 -330 -18 -335 0 -4 9 34
12 167 12 133 0 171 -3 168 -12z m-358 -8 c0 -6 -32 -10 -75 -10 -43 0 -75 4
-75 10 0 6 32 10 75 10 43 0 75 -4 75 -10z"
      />
      <path
        d="M316 478 c-30 -43 -9 -118 34 -118 24 0 50 37 50 70 0 33 -26 70 -50
70 -10 0 -26 -10 -34 -22z m52 -10 c31 -31 0 -105 -33 -78 -25 21 -14 90 15
90 3 0 11 -5 18 -12z"
      />
      <path
        d="M432 458 c-7 -7 -12 -36 -12 -66 0 -52 2 -57 49 -103 40 -41 54 -49
85 -49 l36 0 0 51 c0 66 -24 114 -73 150 -43 31 -66 36 -85 17z m66 -28 c44
-27 72 -76 72 -127 0 -38 -3 -43 -22 -43 -13 0 -41 18 -65 42 -38 38 -43 47
-43 88 0 66 7 71 58 40z"
      />
    </g>
  </svg>
);
